<template>
  <ListOrder platform-order-source="shopee" />
</template>

<script>
import ListOrder from './ListOrder.vue';

export default {
  name: 'ListOrderPlatform',
  components: {
    ListOrder,
  },
};
</script>
